import React from "react";
import Map, { DrawingTools, MapConstant, MapControls,Popup } from "../../../../../lib/Map";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import appConstants from "../../../../../appConstants";
import { compose } from "recompose";
import { withTheme } from "@material-ui/core";
import { withAppConfig } from "../../../../../appConfigContext";
import Events from "../../../../../utilities/EventEmitter";
import DriverMapContent from "./DriverMapContent";
import { ZonePopUpInfo } from "../../../../mapComponents/Popups";

class DriverMap extends React.Component {
  constructor(props) {
    super(props);
    this.childRef = React.createRef();
    this.state = {
      styleName: null,
      zoneInfo: null,
    };
  }

  onScaleDrawingComplete = (...params) => {
    this.childRef.current.onScaleDrawingComplete(...params)
  }

  hideAllPopups = () => {
    this.childRef.current.hideAllPopups();
    this.setState({
      zoneInfo: null,
    });
  };

  setChildRef = (ref) => {
    this.childRef.current = ref;
  }

  mouseMoveOnMap=()=>{
   this.childRef.current.onHoverOutOnMap();
  }

  onZoneClicked = (zoneInfo) => {
    this.setState({ zoneInfo });
  };

  getMapStyleName = (styleName) => {
    if (this.state.styleName !== styleName) {
      this.setState({ styleName: styleName });
    }
  };

  render() {
    const { location: terminalLocation } =
      this.props.userData.userProfile.terminal;
    const { theme } = this.props;
    return (
      <div className={"mapViewContainer"} id="dispatchMapContainer">
        <Map
          zoom={appConstants.MAP_ZOOM_LEVEL}
          initialCenter={terminalLocation}
          center={terminalLocation}
          mapId={"dispatchMap"}
          mapTheme={theme.themeName}
          eventHub={this.props.glEventHub}
          onClick={this.hideAllPopups}
          mapConfig={this.props.configJSON?.maps}
          onMouseMove={this.mouseMoveOnMap}
          thresholdZoomLevel={appConstants.STOP_POPUP_THRESHOLD_ZOOM_LEVEL}
          getMapStyleName={this.getMapStyleName}
        >
          <DrawingTools
            // forceRender updates the options of drawing Manager && updates the configurations of drawings already drawn on map
            // set to true when theme changes
            // forceRender={this.state.themeChanged}
            rectangleOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            polylineOptions={{
              strokeColor: theme.MapDrawingColor,
            }}
            polygonOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            eventHub={Events}
            defaultThemeColor= {theme.commonAppHeaderTabColor}
            onDrawingComplete={this.onScaleDrawingComplete}
          />
          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              showZones: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                terminalID: this.props.userData.userProfile.terminal.code,
                geoJson: this.props.userData.userProfile?.geoJson,
                onZoneClicked: this.onZoneClicked,
              }
            }}
          />
          <DriverMapContent
            {...this.props}
            forwardedRef={this.setChildRef}
            styleName={this.state.styleName}
          />
          {this.state.zoneInfo && (
            <Popup isCloseButton position={this.state.zoneInfo.position}>
              <ZonePopUpInfo data={this.state.zoneInfo.data} />
            </Popup>
          )}
        </Map>
      </div>
    );
  }
}

export default compose(withUserProfile, withTheme(), withAppConfig)(DriverMap);
